"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[787],{

/***/ 90400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37989);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70754);




function ModalButton(props) {
    var handleNext = props.handleNext, text = props.text, form = props.form, type = props.type, alternative = props.alternative, alternativeText = props.alternativeText, disabled = props.disabled, children = props.children, loading = props.loading;
    var handleClick = function(event) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        handleNext();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .ButtonDiv */ .Lw, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                    onClick: handleClick,
                    form: form,
                    type: type,
                    alternative: Boolean(alternative),
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalButton_styles__WEBPACK_IMPORTED_MODULE_2__/* .TypographyButton */ .yU, {
                            children: alternative ? alternativeText : text
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20,
                            color: "inherit"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 82688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CreateAuthCodeMutation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: createAuthCode.ts
 * Project: meki
 * File Created: Monday, 12th December 2022 10:51:29 am
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 21st December 2022 6:13:02 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateAuthCode($params: CreateAuthCodeParams!) {\n    createAuthCode(params: $params) {\n      msg\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateAuthCodeMutation = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 60787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NewSignIn": function() { return /* binding */ NewSignIn; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/screens/registry/loadingAuth.tsx
var loadingAuth = __webpack_require__(62865);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/components/ModalHeader.tsx
var ModalHeader = __webpack_require__(69051);
// EXTERNAL MODULE: ./src/components/ModalContent.tsx + 1 modules
var ModalContent = __webpack_require__(84726);
// EXTERNAL MODULE: ./src/components/ModalButton.tsx
var ModalButton = __webpack_require__(90400);
// EXTERNAL MODULE: ./src/services/firebase.ts + 1 modules
var firebase = __webpack_require__(45997);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/screens/signIn/signIn.styles.ts
var signIn_styles = __webpack_require__(69625);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon_SvgIcon = __webpack_require__(81645);
;// CONCATENATED MODULE: ./src/components/icons/GoogleGLogo.tsx
/*
 * File: GoogleGLogo.tsx
 * Project: meki
 * File Created: Monday, 23rd August 2021 10:00:26 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 23rd August 2021 10:56:32 am
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 




var GoogleGLogoIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon_SvgIcon/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 48 48"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "ab",
                    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                id: "b",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                    xlinkHref: "#ab",
                    overflow: "visible"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipPath: "url(#b)",
                fill: "#FBBC05",
                d: "M0 37V11l17 13z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipPath: "url(#b)",
                fill: "#EA4335",
                d: "M0 11l17 13 7-6.1L48 14V0H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipPath: "url(#b)",
                fill: "#34A853",
                d: "M0 37l30-23 7.9 1L48 0v48H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipPath: "url(#b)",
                fill: "#4285F4",
                d: "M48 48L17 24l-4-3 35-10z"
            })
        ]
    }));
};
var GoogleGLogoWhiteIcon = function(props) {
    return /*#__PURE__*/ _jsxs(SvgIcon, _object_spread_props(_object_spread({
        viewBox: "0 0 49 49"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("path", {
                    id: "ab",
                    fill: "#ffffff",
                    d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                })
            }),
            /*#__PURE__*/ _jsx("clipPath", {
                id: "b",
                children: /*#__PURE__*/ _jsx("use", {
                    xlinkHref: "#ab"
                })
            }),
            /*#__PURE__*/ _jsx("path", {
                clipPath: "url(#b)",
                fill: "#ffffff",
                d: "M0 37V11l17 13z"
            }),
            /*#__PURE__*/ _jsx("path", {
                clipPath: "url(#b)",
                fill: "#ffffff",
                d: "M0 11l17 13 7-6.1L48 14V0H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                clipPath: "url(#b)",
                fill: "#ffffff",
                d: "M0 37l30-23 7.9 1L48 0v48H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                clipPath: "url(#b)",
                fill: "#ffffff",
                d: "M48 48L17 24l-4-3 35-10z"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ../../node_modules/firebase/auth/dist/index.esm.js + 2 modules
var dist_index_esm = __webpack_require__(2498);
// EXTERNAL MODULE: ./src/queries/authCode/mutations/createAuthCode.ts
var createAuthCode = __webpack_require__(82688);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
// EXTERNAL MODULE: ./src/services/sentry.ts
var sentry = __webpack_require__(52353);
// EXTERNAL MODULE: ./src/services/openreplay.ts
var openreplay = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ../../node_modules/@passwordless-id/webauthn/dist/esm/index.js + 6 modules
var esm = __webpack_require__(36389);
// EXTERNAL MODULE: ./src/services/biometricLogin.ts
var biometricLogin = __webpack_require__(56665);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(98449);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/validators/biometricBrowserValidator.ts + 1 modules
var biometricBrowserValidator = __webpack_require__(93213);
;// CONCATENATED MODULE: ./src/screens/signIn/index.tsx
/*
 * File: newIndex.tsx
 * Project: meki
 * File Created: Monday, 12th April 2021 2:50:11 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Monday, 17th July 2023 2:56:46 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 




































var BiometricProcessType;
(function(BiometricProcessType) {
    BiometricProcessType["IDLE"] = "IDLE";
    BiometricProcessType["LOADING"] = "LOADING";
    BiometricProcessType["SUCCESS"] = "SUCCESS";
    BiometricProcessType["ERROR"] = "ERROR";
})(BiometricProcessType || (BiometricProcessType = {}));
var TAG = "[SIGN_IN_SCREEN]";
function NewSignIn() {
    var ref, ref1;
    // Hooks init:
    var router = (0,next_router.useRouter)();
    var routerModal = (0,useModalRouter/* useModalRouter */.r)();
    var ref2 = (0,useAuth/* useAuth */.a)(), firebaseUser = ref2.firebaseUser, appUser = ref2.appUser, authLoading = ref2.loading;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref3 = (0,useSegment/* useSegment */.K)(), track = ref3.track, debugTrack = ref3.debugTrack;
    var showError = (0,firebase/* useShowFirebaseAuthError */.NM)().showError;
    var ref4 = (0,useMekiState/* useMekiState */.c)(), setRegistryFrom = ref4.setRegistryFrom, typeOfSingin = ref4.typeOfSingin, setTypeOfSingin = ref4.setTypeOfSingin, referralCode = ref4.referralCode;
    var ref5 = (0,openreplay/* useOpenReplayTracking */.WK)(), trackIssue = ref5.trackIssue, trackEvent = ref5.trackEvent;
    var phoneCodes = function() {
        return __webpack_require__.e(/* import() */ 3927).then(__webpack_require__.t.bind(__webpack_require__, 73927, 19)).then(function(mod) {
            return mod.phoneCodes;
        });
    };
    // App State
    var ref6 = (0,useOrderState/* useOrderState */.h)(), orderUuid = ref6.orderUuid, setOrderUuid = ref6.setOrderUuid;
    var ref7 = (0,react.useState)(true), showGoogleBtn = ref7[0], setShowGoogleBtn = ref7[1];
    //Local State
    var ref8 = (0,react.useState)(false), awaitGoogle = ref8[0], setAwaitGoogle = ref8[1]; // is true if I'm waiting for google
    var ref9 = (0,react.useState)("\uD83C\uDDE8\uD83C\uDDF1 +56"), phonePrefix = ref9[0], setPhonePrefix = ref9[1];
    var ref10 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            userInput: ""
        }
    }), register = ref10.register, handleSubmit = ref10.handleSubmit, watch = ref10.watch, setValue = ref10.setValue, errors = ref10.formState.errors;
    var userInput = watch("userInput");
    var userInputRef = (0,react.useRef)(userInput);
    var ref11 = (0,react.useState)([
        {
            name: "Chile",
            icon: "\uD83C\uDDE8\uD83C\uDDF1",
            prefix: "+56"
        }, 
    ]), phoneCodeList = ref11[0], setPhoneCodeList = ref11[1];
    var ref12 = (0,react.useState)(false), phoneLoading = ref12[0], setPhoneLoading = ref12[1];
    var ref13 = (0,react.useState)(null), alertModal = ref13[0], setAlertModal = ref13[1];
    var ref14 = (0,react.useState)(BiometricProcessType.IDLE), biometricProcessStatus = ref14[0], setBiometricProcessStatus = ref14[1];
    // Other varriable declaration (useRef, etc)
    var orderUuidRef = (0,react.useRef)(orderUuid);
    var clientRef = (0,react.useRef)(client);
    var hasGeneretedCaptcha = (0,react.useRef)(false);
    var redirect = router.query.redirect;
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,createAuthCode/* CreateAuthCodeMutation */.V)()), 2), sendAuthCode = ref15[0], ref16 = ref15[1], emailLoading = ref16.loading;
    var device = main/* mobileModel */.N7 === "none" ? "".concat(main/* osName */.BF, " ").concat(main/* osVersion */.MM) : "".concat(main/* mobileModel */.N7, " ").concat(main/* osName */.BF, " ").concat(main/* osVersion */.MM);
    var ref17 = (0,react.useState)(false), quickDisableButton = ref17[0], setQuickDisableButton = ref17[1];
    // Effects
    (0,react.useEffect)(function updateOrderUuidRef() {
        orderUuidRef.current = orderUuid;
    }, [
        orderUuid
    ]);
    (0,react.useEffect)(function() {
        void track("log in start");
        setTypeOfSingin("unset");
    }, [
        track,
        setTypeOfSingin
    ]);
    (0,react.useEffect)(function checkLoginAndRedirect() {
        if (authLoading) return;
        utils/* Console.log */.Mn.log({
            msg: TAG + "CheckLoginAndRedirect effect: validate auth",
            firebaseUser: firebaseUser,
            appUser: appUser,
            orderUuid: orderUuidRef.current,
            redirect: redirect,
            authLoading: authLoading
        });
        if (!firebaseUser) {
            utils/* Console.log */.Mn.log({
                msg: TAG + " CheckLoginAndRedirect no firebase user"
            });
            return;
        }
        if (appUser) {
            utils/* Console.log */.Mn.log({
                msg: TAG + " Redirect from signin",
                to: redirect !== null && redirect !== void 0 ? redirect : (0,utils/* getRoute */.Bv)("home"),
                redirect: redirect,
                firebaseUser: firebaseUser,
                appUser: appUser,
                routerModal: routerModal
            });
            void track("log in succeed", {
                referralCode: referralCode
            });
            debugTrack("AUTH", "sign in next", {
                typeOfSingin: typeOfSingin,
                userInput: userInput
            });
            if (redirect === "undefined") {
                return void router.replace((0,utils/* getRoute */.Bv)("home", (referralCode === null || referralCode === void 0 ? void 0 : referralCode.length) > 0 ? {
                    codigo: referralCode
                } : {}));
            }
            return void router.replace({
                pathname: "/inicio",
                query: (0,utils/* removeUndefineds */.ox)({
                    codigo: (referralCode === null || referralCode === void 0 ? void 0 : referralCode.length) > 0 ? referralCode : undefined,
                    pathname: redirect
                })
            }, {
                pathname: redirect,
                query: (0,utils/* removeUndefineds */.ox)({
                    codigo: (referralCode === null || referralCode === void 0 ? void 0 : referralCode.length) > 0 ? referralCode : undefined
                })
            });
        }
        utils/* Console.log */.Mn.log({
            msg: TAG + " Redirect from signin to register cause no appuser",
            to: (0,utils/* getRoute */.Bv)("register"),
            firebaseUser: firebaseUser,
            appUser: appUser
        });
        if (userInput === "") setTypeOfSingin("google");
        debugTrack("AUTH", "sign in next", {
            typeOfSingin: typeOfSingin,
            userInput: userInput
        });
        void routerModal.push((0,utils/* getRoute */.Bv)("register"));
    }, [
        redirect,
        routerModal,
        router,
        setOrderUuid,
        authLoading,
        firebaseUser,
        appUser,
        track,
        referralCode,
        debugTrack,
        typeOfSingin,
        userInput,
        setTypeOfSingin, 
    ]);
    (0,react.useEffect)(function() {
        var handleRedirectResult = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setAwaitGoogle(true);
                            return [
                                4,
                                (0,firebase/* getRedirectResult */.cx)()
                            ];
                        case 1:
                            _state.sent();
                            setAwaitGoogle(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRedirectResult() {
                return _ref.apply(this, arguments);
            };
        }();
        void handleRedirectResult();
    }, []);
    (0,react.useEffect)(function() {
        clientRef.current = client;
    }, [
        client
    ]);
    (0,react.useEffect)(function validateEmailorPhone() {
        if (typeOfSingin === "phone" && /^\+?56/.exec(userInputRef.current)) {
            return;
        }
        if (typeOfSingin === "google") {
            return;
        }
        if (((userInput === null || userInput === void 0 ? void 0 : userInput.length) < 2 && !userInput.startsWith("+") || (userInput === null || userInput === void 0 ? void 0 : userInput.length) < 3 && userInput.startsWith("+")) && typeOfSingin !== "unset") {
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "unset"
            });
            setTypeOfSingin("unset");
            return;
        }
        if ((userInput === null || userInput === void 0 ? void 0 : userInput.length) < 3) return;
        var isNumber = /^\+?\d+$/.test(userInput);
        if (isNumber && typeOfSingin !== "phone") {
            setTypeOfSingin("phone");
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "phone"
            });
            return;
        }
        if (!isNumber && typeOfSingin !== "email") {
            setTypeOfSingin("email");
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "email"
            });
            return;
        }
    }, [
        userInput,
        setTypeOfSingin,
        typeOfSingin,
        debugTrack
    ]);
    (0,react.useEffect)(function updateUserInputRefValue() {
        userInputRef.current = userInput;
    }, [
        userInput
    ]);
    // Logic
    var connectWithGoogle = (0,react.useCallback)(function() {
        void track("log in start google");
        utils/* Console.log */.Mn.log({
            msg: TAG + "Google singin"
        });
        setTypeOfSingin("google");
        debugTrack("AUTH", "set type of input", {
            userInput: userInput,
            type: "google"
        });
        void (0,firebase/* signinWithGoogle */.sN)();
        setAwaitGoogle(true);
    }, [
        track,
        setTypeOfSingin,
        debugTrack,
        userInput
    ]);
    var handleSelectChange = (0,react.useCallback)(function(e) {
        setPhonePrefix(String(e.target.value));
    }, [
        setPhonePrefix
    ]);
    var generateRecaptcha = function() {
        window.recaptchaVerifier = new dist_index_esm/* RecaptchaVerifier */.lI("sign-in-button", {
            size: "invisible",
            callback: function(response) {
                utils/* Console.log */.Mn.log({
                    msg: TAG + "reCAPTCHA solved, allow signInWithPhoneNumber",
                    response: response
                });
            }
        }, (0,firebase/* getFirebaseAuth */.yL)());
    };
    var signInWithCustomFirebaseToken = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(customToken, userData) {
            var userCredential, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!customToken) return [
                            3,
                            4
                        ];
                        debugTrack("AUTH", "sign in with custom token", {});
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,dist_index_esm/* signInWithCustomToken */._p)((0,firebase/* getFirebaseAuth */.yL)(), customToken)
                        ];
                    case 2:
                        userCredential = _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Firebase login",
                            user: userCredential.user
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        debugTrack("AUTH", "error on firebase custom token sign in", {
                            email: userData.email,
                            phone: userData.phone
                        });
                        void (0,sentry/* getSentry */.$)().then(function(Sentry) {
                            Sentry.captureException(error);
                        });
                        void trackIssue("[NEW_REGISTRY_ADITIONAL_INFORMATION_SCREEN_ISSUE]: Firebase User couldn't sign in", error);
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Firebase User couldn't sign in"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(customToken, userData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        trackIssue
    ]);
    var emailSingIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            var response, message, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        void track("send code email");
                        debugTrack("AUTH", "send code", {
                            type: "email",
                            userInput: userInput
                        });
                        setRegistryFrom({
                            name: "",
                            lastName: "",
                            email: userInput,
                            phonePrefix: "",
                            phone: "",
                            rut: "",
                            code: "",
                            source: ""
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            6
                        ]);
                        return [
                            4,
                            sendAuthCode({
                                variables: {
                                    params: {
                                        email: userInput,
                                        device: device,
                                        browser: main/* browserName */.KC
                                    }
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        message = response.data.createAuthCode.msg;
                        if (message === "Email send successfully") {
                            void trackEvent(TAG + "Email send successfully");
                            utils/* Console.log */.Mn.log({
                                msg: TAG + "email sent",
                                message: message
                            });
                            debugTrack("AUTH", "sign in next", {
                                typeOfSingin: typeOfSingin,
                                userInput: userInput
                            });
                            void routerModal.push((0,utils/* getRoute */.Bv)("verifyCode", {
                                biometricFailed: (biometricFailed === null || biometricFailed === void 0 ? void 0 : biometricFailed.toString()) || "false"
                            }));
                            return [
                                2
                            ];
                        }
                        if (message === "Error sending email") {
                            throw new Error("Email not sent");
                        }
                        return [
                            3,
                            6
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            4,
                            (0,sentry/* getSentry */.$)().then(function(Sentry) {
                                Sentry.captureException(error);
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Error email not sent", error)
                        ];
                    case 5:
                        _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Error; email not sent"
                        });
                        setAlertModal({
                            title: "No pudimos enviar el correo",
                            content: "Prueba iniciando sesi\xf3n con tu n\xfamero de tel\xe9fono"
                        });
                        debugTrack("AUTH", "send code error", {
                            type: "email",
                            userInput: userInput
                        });
                        return [
                            2
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        device,
        routerModal,
        sendAuthCode,
        setRegistryFrom,
        track,
        trackEvent,
        trackIssue,
        typeOfSingin,
        userInput, 
    ]);
    var phoneSingIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            var phoneNumber, phoneWithoutSpaces, confirmationResult, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        void track("send code phone");
                        phoneNumber = phonePrefix.split(" ")[1] + " " + userInput;
                        debugTrack("AUTH", "send code", {
                            type: "phone",
                            phoneNumber: phoneNumber
                        });
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Singin con numero de tel\xe9fono",
                            phoneNumber: phoneNumber
                        });
                        setRegistryFrom({
                            name: "",
                            lastName: "",
                            email: "",
                            phonePrefix: phonePrefix,
                            phone: phoneNumber,
                            rut: "",
                            code: "",
                            source: ""
                        });
                        if (!hasGeneretedCaptcha.current) {
                            generateRecaptcha();
                            hasGeneretedCaptcha.current = true;
                        } else {
                            if (window.recaptchaWidgetId === undefined) {
                                void window.recaptchaVerifier.render().then(function(widgetId) {
                                    window.recaptchaWidgetId = widgetId;
                                    window.grecaptcha.reset(widgetId);
                                });
                            } else {
                                window.grecaptcha.reset(window.recaptchaWidgetId);
                            }
                        }
                        phoneWithoutSpaces = phoneNumber.split(" ")[0] + phoneNumber.split(" ")[1];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            9
                        ]);
                        setPhoneLoading(true);
                        return [
                            4,
                            (0,dist_index_esm/* signInWithPhoneNumber */.$g)((0,firebase/* getFirebaseAuth */.yL)(), phoneWithoutSpaces, window.recaptchaVerifier)
                        ];
                    case 2:
                        confirmationResult = _state.sent();
                        // SMS sent.
                        window.confirmationResult = confirmationResult;
                        void trackEvent(TAG + "SMS send successfully");
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "SMS sent",
                            confirmationResult: confirmationResult
                        });
                        debugTrack("AUTH", "sign in next", {
                            typeOfSingin: typeOfSingin,
                            userInput: userInput
                        });
                        void routerModal.push((0,utils/* getRoute */.Bv)("verifyCode", {
                            biometricFailed: (biometricFailed === null || biometricFailed === void 0 ? void 0 : biometricFailed.toString()) || "false"
                        }));
                        setPhoneLoading(false);
                        return [
                            2
                        ];
                    case 3:
                        error = _state.sent();
                        debugTrack("AUTH", "send code error", {
                            type: "phone",
                            phoneNumber: phoneNumber
                        });
                        if (!(0,firebase/* isAuthError */.f1)(error)) return [
                            3,
                            5
                        ];
                        showError(error);
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Firebase error SMS not sent", error)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Error SMS not sent", error)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            4,
                            (0,sentry/* getSentry */.$)().then(function(Sentry) {
                                Sentry.captureException(error);
                            })
                        ];
                    case 8:
                        _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Error; SMS not sent"
                        });
                        setPhoneLoading(false);
                        return [
                            2
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        phonePrefix,
        routerModal,
        setRegistryFrom,
        showError,
        track,
        trackEvent,
        trackIssue,
        typeOfSingin,
        userInput, 
    ]);
    var simpleSignIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeOfSingin === "email")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            emailSingIn(biometricFailed)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(typeOfSingin === "phone")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            phoneSingIn(biometricFailed)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        debugTrack("AUTH", "ignore signin next button", {
                            typeOfSingin: typeOfSingin,
                            userInput: userInput,
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        emailSingIn,
        phoneSingIn,
        typeOfSingin,
        userInput,
        emailLoading,
        phoneLoading,
        debugTrack, 
    ]);
    var onSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var isAvailableBiometric, userIdentifier, ref, userData, userExists, ref1, userCredentials, ref2, challenge, login, ref3, verifyLogin, error, error1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (quickDisableButton) return [
                        2
                    ];
                    setQuickDisableButton(true);
                    if (emailLoading && typeOfSingin === "email" || phoneLoading && typeOfSingin === "phone") {
                        utils/* Console.log */.Mn.log({
                            msg: "DEBUG Block due emailLoading",
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading,
                            typeOfSingin: typeOfSingin
                        });
                        debugTrack("AUTH", "block signin next button", {
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading,
                            userInput: userInput
                        });
                        return [
                            2
                        ];
                    }
                    isAvailableBiometric = !!window.PublicKeyCredential && (0,biometricBrowserValidator/* browserIsValidForBiometric */.E)();
                    userIdentifier = typeOfSingin === "email" ? userInput : phonePrefix.split(" ")[1] + userInput;
                    return [
                        4,
                        biometricLogin/* UserApi.get */.W.get("/".concat(userIdentifier))
                    ];
                case 1:
                    ref = _state.sent(), userData = ref.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG userData",
                        userData: userData
                    });
                    debugTrack("AUTH", "userData", {
                        userData: userData,
                        isAvailableBiometric: isAvailableBiometric
                    });
                    userExists = userData && userData.userId !== null;
                    if (!(isAvailableBiometric && userExists)) return [
                        3,
                        18
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        15,
                        ,
                        17
                    ]);
                    return [
                        4,
                        biometricLogin/* BiometricApi.get */.P.get("/credentials/".concat(userData.email))
                    ];
                case 3:
                    ref1 = _state.sent(), userCredentials = ref1.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG user credentials ids",
                        userCredentials: userCredentials
                    });
                    debugTrack("AUTH", "user credentials ids", {
                        userCredentials: userCredentials
                    });
                    if (!((userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.credentialsIds.length) > 0)) return [
                        3,
                        12
                    ];
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        ,
                        11
                    ]);
                    setBiometricProcessStatus(BiometricProcessType.LOADING);
                    return [
                        4,
                        biometricLogin/* BiometricApi.get */.P.get("/challenge/".concat(userData.email))
                    ];
                case 5:
                    ref2 = _state.sent(), challenge = ref2.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG challenge",
                        challenge: challenge
                    });
                    debugTrack("AUTH", "DEBUG challenge", {
                        challenge: challenge.challenge
                    });
                    return [
                        4,
                        esm/* client.authenticate */.Lp.authenticate(userCredentials.credentialsIds, challenge.challenge, {
                            authenticatorType: "auto",
                            userVerification: "required"
                        })
                    ];
                case 6:
                    login = _state.sent();
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG verify biometric login",
                        login: login,
                        origin: window.location.origin,
                        userEmail: userData.email
                    });
                    debugTrack("AUTH", "DEBUG verify biometric login", {
                        login: login,
                        origin: window.location.origin,
                        userEmail: userData.email
                    });
                    track("biometric login attempt");
                    return [
                        4,
                        biometricLogin/* BiometricApi.post */.P.post("/login", {
                            authentication: login,
                            origin: window.location.origin,
                            userEmail: userData.email
                        })
                    ];
                case 7:
                    ref3 = _state.sent(), verifyLogin = ref3.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG verifyLogin",
                        verifyLogin: verifyLogin
                    });
                    debugTrack("AUTH", "DEBUG verifyLogin", {
                        verifyLogin: verifyLogin
                    });
                    setBiometricProcessStatus(BiometricProcessType.SUCCESS);
                    track("biometric login success");
                    return [
                        4,
                        signInWithCustomFirebaseToken(verifyLogin.loginCustomToken, userData)
                    ];
                case 8:
                    _state.sent();
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    if ((0,_instanceof/* default */.Z)(error, DOMException)) {
                        utils/* Console.log */.Mn.log({
                            msg: "DEBUG error",
                            error: error
                        });
                        debugTrack("AUTH", "ERROR biometric login (DOMException)", {
                            error: error.message,
                            userEmail: userData.email
                        });
                    }
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG error on biometric login"
                    });
                    debugTrack("AUTH", "ERROR  biometric login", {
                        error: error,
                        userEmail: userData.email
                    });
                    setQuickDisableButton(false);
                    track("biometric login error");
                    setBiometricProcessStatus(BiometricProcessType.ERROR);
                    setTimeout(function() {
                        setBiometricProcessStatus(BiometricProcessType.IDLE);
                    }, 2000);
                    return [
                        4,
                        simpleSignIn(true)
                    ];
                case 10:
                    _state.sent();
                    return [
                        2
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    setQuickDisableButton(false);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn()
                    ];
                case 13:
                    _state.sent();
                    return [
                        2
                    ];
                case 14:
                    return [
                        3,
                        17
                    ];
                case 15:
                    error1 = _state.sent();
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG error on biometric login"
                    });
                    debugTrack("AUTH", "ERROR  biometric login", {
                        error: error1,
                        userEmail: userData.email
                    });
                    setQuickDisableButton(false);
                    track("biometric login error");
                    setBiometricProcessStatus(BiometricProcessType.ERROR);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn(true)
                    ];
                case 16:
                    _state.sent();
                    return [
                        2
                    ];
                case 17:
                    return [
                        3,
                        20
                    ];
                case 18:
                    setQuickDisableButton(false);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn()
                    ];
                case 19:
                    _state.sent();
                    return [
                        2
                    ];
                case 20:
                    return [
                        2
                    ];
            }
        });
    }), [
        quickDisableButton,
        emailLoading,
        typeOfSingin,
        phoneLoading,
        userInput,
        phonePrefix,
        debugTrack,
        track,
        signInWithCustomFirebaseToken,
        simpleSignIn, 
    ]);
    var handleKeyDown = function(event) {
        if (event.key === "Backspace" && (userInput === "+56" || userInput === "56") && typeOfSingin === "phone") {
            setValue("userInput", "");
        }
    };
    var handleFocus = function() {
        setShowGoogleBtn(false);
    };
    var handleBlur = function(event) {
        if (event.target.value.length <= 5) {
            setShowGoogleBtn(true);
        }
    };
    var enabledGoogleSignin = (0,firebase/* isValidGoogleSigninNavigator */.Cs)() && false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            awaitGoogle && /*#__PURE__*/ (0,jsx_runtime.jsx)(loadingAuth/* LoadingAuthProgress */.y, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* ContentContainer */.E, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader/* Header */.h, {
                        title: "Tus datos",
                        backIcon: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* CenterDiv */.og, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* Form */.l0, {
                                    onSubmit: handleSubmit(onSubmit),
                                    noValidate: true,
                                    id: "my-form",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* AskDataTypography */.vt, {
                                            children: "\xbfCu\xe1l es tu tel\xe9fono celular o tu correo electr\xf3nico?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* WhyDataTypography */.Mt, {
                                            children: "Te enviaremos un c\xf3digo de verificaci\xf3n."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* InputDiv */.Xl, {
                                            children: [
                                                typeOfSingin === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            id: "sign-in-button"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* PhonePrefixSelect */.ap, {
                                                            variant: "outlined",
                                                            size: "small",
                                                            value: phonePrefix,
                                                            renderValue: function(selected) {
                                                                return selected;
                                                            },
                                                            onChange: handleSelectChange,
                                                            onOpen: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                var codes;
                                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                phoneCodes()
                                                                            ];
                                                                        case 1:
                                                                            codes = _state.sent();
                                                                            setPhoneCodeList(codes);
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            }),
                                                            children: phoneCodeList === null || phoneCodeList === void 0 ? void 0 : phoneCodeList.map(function(option) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                    value: "".concat(option.icon, " ").concat(option.prefix),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* IconListItemText */.S0, {
                                                                            children: option.icon
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                                            children: option.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            variant: "body2",
                                                                            color: "text.secondary",
                                                                            children: option.prefix
                                                                        })
                                                                    ]
                                                                }, option.name);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                    type: "email",
                                                    variant: "outlined",
                                                    size: "small"
                                                }, register("userInput", {
                                                    required: "Debes ingresar tu correo o tel\xe9fono",
                                                    onChange: function(event) {
                                                        return setValue("userInput", event.target.value.toLowerCase().replace(/\s/g, ""));
                                                    },
                                                    validate: function(value) {
                                                        if (typeOfSingin == "phone") {
                                                            if (phonePrefix.split(" ")[1] === "+56") {
                                                                if (value.length < 9) {
                                                                    return "Tel\xe9fono incompleto";
                                                                }
                                                                if (value.length > 9) {
                                                                    return "Tel\xe9fono muy largo";
                                                                }
                                                            } else {
                                                                if (phonePrefix.split(" ")[1].length + value.length > 15) {
                                                                    return "Tel\xe9fono muy largo";
                                                                }
                                                            }
                                                        } else {
                                                            if (/^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.exec(userInput)) {
                                                                return true;
                                                            } else {
                                                                return "Este email est\xe1 incompleto \uD83E\uDD37‍♀";
                                                            }
                                                        }
                                                    }
                                                })), {
                                                    label: typeOfSingin === "unset" ? "Ingresa tu tel\xe9fono o correo" : typeOfSingin === "email" ? "Correo electr\xf3nico" : "N\xfamero de tel\xe9fono",
                                                    value: typeOfSingin === "phone" ? userInput.replace(/^\+?56/, "") : userInput,
                                                    error: Boolean((ref = errors.userInput) === null || ref === void 0 ? void 0 : ref.message),
                                                    helperText: (ref1 = errors.userInput) === null || ref1 === void 0 ? void 0 : ref1.message,
                                                    onKeyDown: handleKeyDown,
                                                    onFocus: handleFocus,
                                                    onBlur: handleBlur
                                                }))
                                            ]
                                        })
                                    ]
                                }),
                                showGoogleBtn && enabledGoogleSignin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* DividerDiv */.AL, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* DividerLine */.xN, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* DividerText */.lX, {
                                                    children: "o"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* DividerLine */.xN, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* GoogleButton */.VL, {
                                            variant: "contained",
                                            onClick: connectWithGoogle,
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleGLogoIcon, {}),
                                            size: "large",
                                            children: "Ingresar con Google"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* GooglePlaceHolder */.xU, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButton/* ModalButton */.m, {
                        form: "my-form",
                        type: "submit",
                        handleNext: handleSubmit(onSubmit),
                        text: "Siguiente",
                        disabled: quickDisableButton || authLoading || biometricProcessStatus === BiometricProcessType.LOADING || phoneLoading && typeOfSingin === "phone" || emailLoading && typeOfSingin === "email"
                    }),
                    alertModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                        open: true,
                        title: alertModal.title,
                        setOpen: function(open) {
                            return !open && setAlertModal(null);
                        },
                        content: alertModal.content,
                        actions: [
                            {
                                text: "Ok",
                                onActionClick: function() {
                                    return setAlertModal(null);
                                },
                                variant: "contained"
                            }, 
                        ]
                    })
                ]
            }),
            (phoneLoading || emailLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* GreyOverlay */.fD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* LoaderComponentContainer */.Mq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* AskDataTypography */.vt, {
                            children: phoneLoading && typeOfSingin === "phone" ? "Enviando SMS..." : "Enviando correo..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        })
                    ]
                })
            }),
            biometricProcessStatus !== BiometricProcessType.IDLE && /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* GreyOverlay */.fD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_styles/* LoaderComponentContainer */.Mq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(signIn_styles/* AskDataTypography */.vt, {
                            children: biometricProcessStatus === BiometricProcessType.LOADING ? "Solicitando biometr\xeda..." : biometricProcessStatus === BiometricProcessType.SUCCESS ? "Iniciando sesi\xf3n..." : "Error al obtener biometr\xeda"
                        }),
                        (biometricProcessStatus === BiometricProcessType.LOADING || biometricProcessStatus === BiometricProcessType.SUCCESS) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        }),
                        biometricProcessStatus === BiometricProcessType.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/images/warningIcon.png",
                            alt: "Check",
                            width: 30,
                            height: 30
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 56665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ BiometricApi; },
/* harmony export */   "W": function() { return /* binding */ UserApi; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60031);


var BiometricApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL_URI */ .r8, "/biometric"),
    headers: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ ? {
        secret: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ
    } : {}
});
var UserApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL_URI */ .r8, "/client/user"),
    headers: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ ? {
        secret: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ
    } : {}
});


/***/ })

}]);